import React, { useEffect, useState } from "react";
import TableTopBar from "../../modal/tableTopBar";
import FadeIn from "react-fade-in";
import { TableSortIconDownArrow } from "../../../utils/icons/defaultIcons";
import Table from "../../../atom/table";
import ComponentMap from "../../../atom/componentmap";
import ThemedButton from "../../../atom/ThemedButton/themedButton";
import {
  addDisplayGroup,
  getAllDisplayGroupEntities,
  getDisplayGroupById,
  updateDisplayGroup,
} from "../../../services/api";
import { useNavigate, useParams } from "react-router-dom";
import * as loaderLottie from "../../../utils/lottie/loaderLottie.json";
import { Backdrop } from "@mui/material";
import Lottiefy from "../../../atom/lottie/lottie";
import { actualDataToMapData } from "../../../services/utilities";
import Notification from "../../../atom/Notification";
import { group } from "console";

function NewGroup() {
  const params = useParams();
  const navigate = useNavigate();
  const [loader, setLoader] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  const [groupEntities, setGroupEntities] = useState<any>([]);
  const [usersNotFound, setUsersNotFound] = useState<boolean>(false);
  // users states
  const [filteredUsers, setFilteredUsers] = useState<any>([]);
  const [searchText, setSearchText] = useState<any>("");
  const [handleKeyPress, setHandleKeyPress] = useState<boolean>(true);

  // groups states
  const [groupsSearchText, setGroupsSearchText] = useState<any>("");
  const [groupsHandleKeyPress, setGroupsHandleKeyPress] =
    useState<boolean>(true);
  const [filteredGroups, setFilteredGroups] = useState<any>([]);
  const [groupsNotFound, setGroupsNotFound] = useState<boolean>(false);

  // phonenumbers states
  const [didsSearchText, setDidsSearchText] = useState<any>("");
  const [didsHandleKeyPress, setDidsHandleKeyPress] = useState<boolean>(true);
  const [filtereddids, setFiltereddids] = useState<any>([]);
  const [didsNotFound, setDidsNotFound] = useState<boolean>(false);

  const [userTableTitles, setUserTableTitles] = useState<any>([
    {
      key: "all",
      table: "users",
      type: "checkbox",
      selectAll: true,
    },
    { key: "extension", title: "Extension", icon: <TableSortIconDownArrow /> },
    {
      key: "first_name",
      title: "First Name",
      icon: <TableSortIconDownArrow />,
    },
    { key: "last_name", title: "Last Name", icon: <TableSortIconDownArrow /> },
  ]);

  const [userTableData, setUserTableData] = useState<any>([]);

  const [groupsTableTitles, setGroupsTableTitles] = useState<any>([
    {
      key: "all",
      table: "groups",
      type: "checkbox",
      selectAll: true,
      checked: false,
    },
    { key: "extension", title: "Extension", icon: <TableSortIconDownArrow /> },
    { key: "name", title: "Group Name", icon: <TableSortIconDownArrow /> },
  ]);

  const [groupsTableData, setGroupsTableData] = useState<any>([]);

  const [phoneNumbersTableTitles, setPhoneNumbersTableTitles] = useState<any>([
    {
      key: "all",
      table: "dids",
      type: "checkbox",
      selectAll: true,
    },
    { key: "did", title: "Phone Number", icon: <TableSortIconDownArrow /> },
    {
      key: "incomingName",
      title: "Description",
      icon: <TableSortIconDownArrow />,
    },
  ]);

  const [phoneNumbersTableData, setPhoneNumbersTableData] = useState<any>([]);

  const [displayGroupName, setDisplayGroupName] = useState<any>([
    {
      title: "Display Group Name",
      name: "name",
      type: "text",
      value: "",
    },
  ]);

  const getGroupEntities = () => {
    setLoader(true);
    getAllDisplayGroupEntities().then((result: any) => {
      const groupEntitiesResult = result?.data?.data;
      if (!result?.success || groupEntitiesResult?.length === 0) {
        setLoader(false);
      } else {
        setLoader(false);
      }
      setUserTableData(
        groupEntitiesResult?.users_l.map((node: any) => ({
          ...node,
          type: "users",
        }))
      );
      setGroupsTableData(
        groupEntitiesResult?.call_groups_l.map((node: any) => ({
          ...node,
          type: "groups",
        }))
      );
      setPhoneNumbersTableData(
        groupEntitiesResult?.dids_l.map((node: any) => ({
          ...node,
          type: "dids",
        }))
      );
      setGroupEntities(groupEntitiesResult);
    });
  };

  const handleSelect = (action: string, data: any) => {
    // users check
    if (data?.type === "users") {
      const updatedData = userTableData.map((node: any) => ({
        ...node,
        checked: node?.uuid === data?.uuid ? !node.checked : node.checked,
      }));

      setUserTableData(updatedData);
      if (searchText !== "") {
        const updatedData2 = filteredUsers.map((node: any) => ({
          ...node,
          checked: node?.uuid === data?.uuid ? !node.checked : node.checked,
        }));

        setFilteredUsers(updatedData2);
      }
    }
    // groups check
    else if (data?.type === "groups") {
      setGroupsTableData((prevData: any[]) =>
        prevData?.map((node) => ({
          ...node,
          checked: node?.uuid === data?.uuid ? !node.checked : node.checked, // Toggle only the matching node
        }))
      );
      if (groupsSearchText !== "") {
        setFilteredGroups((prevData: any[]) =>
          prevData?.map((node) => ({
            ...node,
            checked: node?.uuid === data?.uuid ? !node.checked : node.checked, // Toggle only the matching node
          }))
        );
      }
    }
    // dids check
    else if (data?.type === "dids") {
      setPhoneNumbersTableData((prevData: any[]) =>
        prevData?.map((node) => ({
          ...node,
          checked: node?.did === data?.did ? !node.checked : node.checked, // Toggle only the matching node
        }))
      );
      if (didsSearchText !== "") {
        setFiltereddids((prevData: any[]) =>
          prevData?.map((node) => ({
            ...node,
            checked: node?.did === data?.did ? !node.checked : node.checked, // Toggle only the matching node
          }))
        );
      }
    }
  };

  const handleSelectAll = (action: string, data: any) => {
    // users
    if (data?.table === "users") {
      setUserTableTitles((prevData: any[]) =>
        prevData?.map((node) => ({
          ...node,
          checked: node?.key === data?.key ? !node?.checked : node?.checked, // Toggle only the matching node
        }))
      );
      if (searchText !== "") {
        const toggleValue = !userTableTitles[0]?.checked;

        // 1. Update filtered users
        const updatedFilteredUsers = filteredUsers.map((node: any) => ({
          ...node,
          checked: toggleValue,
        }));

        setFilteredUsers(updatedFilteredUsers);

        // 2. Use a Map for safe, fast lookups
        const checkedMap = new Map(
          updatedFilteredUsers.map((u: any) => [u.uuid, u.checked]) // replace `uuid` with your real key
        );

        setUserTableData((prevData: any[]) =>
          prevData.map((user: any) => {
            const newChecked = checkedMap.get(user.uuid); // replace `uuid` here too
            return newChecked !== undefined
              ? { ...user, checked: newChecked }
              : user;
          })
        );
      } else {
        setUserTableData((prevData: any[]) =>
          prevData?.map((node) => ({
            ...node,
            checked: !userTableTitles[0]?.checked, // Toggle only the matching node
          }))
        );
      }
    }

    // groups
    if (data?.table === "groups") {
      setGroupsTableTitles((prevData: any[]) =>
        prevData?.map((node) => ({
          ...node,
          checked: node?.key === data?.key ? !node.checked : node.checked, // Toggle only the matching node
        }))
      );

      if (groupsSearchText !== "") {
        const toggleValue = !groupsTableTitles[0]?.checked;

        // 1. Update filtered users
        const updatedFilteredGroups = filteredGroups.map((node: any) => ({
          ...node,
          checked: toggleValue,
        }));

        setFilteredGroups(updatedFilteredGroups);

        // 2. Use a Map for safe, fast lookups
        const checkedMap = new Map(
          updatedFilteredGroups.map((u: any) => [u.uuid, u.checked]) // replace `uuid` with your real key
        );

        setGroupsTableData((prevData: any[]) =>
          prevData.map((user: any) => {
            const newChecked = checkedMap.get(user.uuid); // replace `uuid` here too
            return newChecked !== undefined
              ? { ...user, checked: newChecked }
              : user;
          })
        );
      } else {
        setGroupsTableData((prevData: any[]) =>
          prevData?.map((node) => ({
            ...node,
            checked: !groupsTableTitles[0]?.checked, // Toggle only the matching node
          }))
        );
      }
    }

    // dids
    if (data?.table === "dids") {
      setPhoneNumbersTableTitles((prevData: any[]) =>
        prevData?.map((node) => ({
          ...node,
          checked: node?.key === data?.key ? !node.checked : node.checked, // Toggle only the matching node
        }))
      );
      if (didsSearchText !== "") {
        const toggleValue = !phoneNumbersTableTitles[0]?.checked;

        // 1. Update filtered users
        const updatedFilteredDids = filtereddids.map((node: any) => ({
          ...node,
          checked: toggleValue,
        }));

        setFiltereddids(updatedFilteredDids);

        // 2. Use a Map for safe, fast lookups
        const checkedMap = new Map(
          updatedFilteredDids.map((u: any) => [u.did, u.checked]) // replace `uuid` with your real key
        );

        setPhoneNumbersTableData((prevData: any[]) =>
          prevData.map((user: any) => {
            const newChecked = checkedMap.get(user.did); // replace `uuid` here too
            return newChecked !== undefined
              ? { ...user, checked: newChecked }
              : user;
          })
        );
      } else {
        setPhoneNumbersTableData((prevData: any[]) =>
          prevData?.map((node) => ({
            ...node,
            checked: !phoneNumbersTableTitles[0]?.checked, // Toggle only the matching node
          }))
        );
      }
    }
  };

  const actionHandler = (action: string, data: any, index: number) => {
    const actionsMap: any = {
      change: handleSelect,
      selectall: handleSelectAll,
    };
    const act = actionsMap[action];
    if (act) {
      act(action, data);
    } else {
      console.log("actionHandler Error");
    }
  };

  const handleAddUpdate = () => {
    setButtonLoader(true);
    const users = userTableData?.filter((node: any) => node?.checked);
    const groups = groupsTableData?.filter((node: any) => node?.checked);
    const dids = phoneNumbersTableData?.filter((node: any) => node?.checked);
    const data = {
      name: displayGroupName[0]?.value,
      users_l: users?.map((node: any) => node?.extension),
      call_groups_l: groups?.map((node: any) => node?.extension),
      dids_l: dids?.map((node: any) => node?.did),
    };

    if (!data?.name) {
      Notification("Required", "Display group name required", "danger");
      setButtonLoader(false);
      return;
    }

    if (
      data?.users_l?.length === 0 &&
      data?.call_groups_l?.length === 0 &&
      data?.dids_l?.length === 0
    ) {
      Notification(
        "Required",
        "At least one User, Group, or Phone Number must be selected",
        "danger"
      );
      setButtonLoader(false);
      return;
    }
    const apiCall = params?.uuid
      ? updateDisplayGroup(params?.uuid, data)
      : addDisplayGroup(data);

    apiCall.then((result: any) => {
      setButtonLoader(false);
      if (result?.success) {
        navigate("/app/tools/displaygroups");
      } else {
        let msg = result?.message || "Something went wrong";
        Notification(
          "Failed",
          msg.charAt(0).toUpperCase() + msg.slice(1),
          "danger"
        );
      }
    });
  };
  const getGroupData = (uuid: any) => {
    setLoader(true);
    getDisplayGroupById(uuid).then((result: any) => {
      if (!result?.success) {
        setLoader(false);
      } else {
        setLoader(false);
      }
      const groupData = result?.data?.data;
      setDisplayGroupName(
        actualDataToMapData([...displayGroupName], groupData)
      );
      setUserTableData(
        groupData?.users_l.map((node: any) => ({
          ...node,
          checked: node.is_selected,
          type: "users",
        }))
      );
      setGroupsTableData(
        groupData?.call_groups_l.map((node: any) => ({
          ...node,
          checked: node.is_selected,
          type: "groups",
        }))
      );
      setPhoneNumbersTableData(
        groupData?.dids_l.map((node: any) => ({
          ...node,
          checked: node.is_selected,
          type: "dids",
        }))
      );
    });
  };

  // users search

  const handleSearch = (data: string) => {
    if (data === "") {
      const updatedTitles = [...userTableTitles];
      if (updatedTitles[0]) {
        updatedTitles[0].checked = false;
      }
      setUserTableTitles(updatedTitles);
    }
    setSearchText(data);
    const userTableDataCopy = [...userTableData];
    const filteredUserData = userTableDataCopy?.filter((user: any) => {
      const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
      const extension = user.extension.toLowerCase();
      const searchLower = data?.toLowerCase();

      return fullName.includes(searchLower) || extension.includes(searchLower);
    });
    if (filteredUserData?.length === 0) {
      setUsersNotFound(true);
    } else {
      setUsersNotFound(false);
    }

    setFilteredUsers(filteredUserData);
    // setUserTableData(filteredUserData);
  };

  // groups search

  const handleGroupsSearch = (data: string) => {
    if (data === "") {
      const updatedTitles = [...groupsTableTitles];
      if (updatedTitles[0]) {
        updatedTitles[0].checked = false;
      }
      setGroupsTableTitles(updatedTitles);
    }
    setGroupsSearchText(data);
    const filteredData = groupsTableData?.filter((grp: any) => {
      const grpName = grp?.name?.toLowerCase();
      const extension = grp?.extension?.toLowerCase();
      const searchLower = data?.toLowerCase();

      return grpName.includes(searchLower) || extension.includes(searchLower);
    });
    if (filteredData?.length === 0) {
      setGroupsNotFound(true);
    } else {
      setGroupsNotFound(false);
    }
    setFilteredGroups(filteredData);
  };

  // phonenumbers search

  const handleDidsSearch = (data: string) => {
    if (data === "") {
      const updatedTitles = [...phoneNumbersTableTitles];
      if (updatedTitles[0]) {
        updatedTitles[0].checked = false;
      }
      setPhoneNumbersTableTitles(updatedTitles);
    }
    setDidsSearchText(data);
    const filteredData = phoneNumbersTableData?.filter((did: any) => {
      const name = did?.incomingName?.toLowerCase();
      const dids = did?.did?.toLowerCase();
      const searchLower = data?.toLowerCase();

      return name?.includes(searchLower) || dids.includes(searchLower);
    });
    if (filteredData?.length === 0) {
      setDidsNotFound(true);
    } else {
      setDidsNotFound(false);
    }
    setFiltereddids(filteredData);
    // setUserTableData(filteredUsers);
  };

  useEffect(() => {
    if (params?.uuid) {
      getGroupData(params?.uuid);
    } else {
      getGroupEntities();
    }
  }, []);
  return (
    <div
      data-testid="newGroup"
      className=" h-full py-3 grid grid-flow-col relative gap-2.5 overflow-x-auto overflow-y-hidden"
    >
      <Backdrop className="!z-[99999999999]" open={loader}>
        <Lottiefy loop={true} json={loaderLottie} height={100} width={100} />
      </Backdrop>
      {/* <FadeIn>
        <> */}
      <div className="h-[calc(100vh-125px)] min-w-[280px] w-full bg-[#FFFFFF] rounded-md">
        <div className="font-bold p-4">
          {params?.uuid ? "Update" : "Add"} Display Group
        </div>
        <ComponentMap data={displayGroupName} setData={setDisplayGroupName} />
        <div className="text-right px-1">
          <ThemedButton
            children={params?.uuid ? "Update" : "Add"}
            click={handleAddUpdate}
            valiData={displayGroupName}
            change={setDisplayGroupName}
            theme={"primary"}
            loading={buttonLoader}
          />
        </div>
      </div>

      {/* users */}
      <div className="h-[calc(100vh-125px)] py-3 w-[calc(100vw-1420px)] min-w-[400px] bg-[#FFFFFF] rounded-md">
        {/* <div className="p-0 py-3 "> */}
        <TableTopBar
          title={"Users"}
          search_class="!w-[200px] absolute right-2"
          search={true}
          handleSearch={handleSearch}
          setSearchText={setSearchText}
          handleKeyPress={handleKeyPress}
          setHandleKeyPress={setHandleKeyPress}
        />
        <div className="h-[calc(100vh-125px)] mt-5 w-full">
          <Table
            tableTitles={userTableTitles}
            tableData={searchText !== "" ? filteredUsers : userTableData}
            // tableData={userTableData}
            setTableData={setUserTableData}
            setTableTitles={setUserTableTitles}
            actionHandler={actionHandler}
            resultNotFound={usersNotFound}
            width={"w-[calc(100vw-1420px)] min-w-[400px]"}
            scrollHeight={"h-[calc(100vh-210px)] overflow-y-auto"}
          />
        </div>
        {/* </div> */}
      </div>

      {/* groups */}
      <div className="h-[calc(100vh-125px)] py-3 w-[calc(100vw-1420px)] min-w-[400px] bg-[#FFFFFF] rounded-md">
        {/* <div className="p-0 py-3"> */}
        <TableTopBar
          title={"Groups"}
          search_class="!w-[200px] absolute right-2"
          search={true}
          handleSearch={handleGroupsSearch}
          setSearchText={setGroupsSearchText}
          handleKeyPress={groupsHandleKeyPress}
          setHandleKeyPress={setGroupsHandleKeyPress}
        />
        <div className=" mt-5 w-full">
          <Table
            tableTitles={groupsTableTitles}
            tableData={
              groupsSearchText !== "" ? filteredGroups : groupsTableData
            }
            setTableData={setGroupsTableData}
            setTableTitles={setGroupsTableTitles}
            actionHandler={actionHandler}
            resultNotFound={groupsNotFound}
            width={"w-[calc(100vw-1420px)] min-w-[400px]"}
            scrollHeight={"h-[calc(100vh-210px)] overflow-y-auto"}
          />
        </div>
        {/* </div> */}
      </div>

      {/* phone numbers */}
      <div className="h-[calc(100vh-125px)] py-3 w-[calc(100vw-1420px)] min-w-[400px] bg-[#FFFFFF] rounded-md">
        {/* <div className="p-0 py-3"> */}
        <TableTopBar
          title={"Phone Numbers"}
          search_class="!w-[200px] absolute right-2"
          search={true}
          handleSearch={handleDidsSearch}
          setSearchText={setDidsSearchText}
          handleKeyPress={didsHandleKeyPress}
          setHandleKeyPress={setDidsHandleKeyPress}
        />
        <div className=" mt-5 w-full">
          <Table
            tableTitles={phoneNumbersTableTitles}
            tableData={
              didsSearchText !== "" ? filtereddids : phoneNumbersTableData
            }
            setTableData={setPhoneNumbersTableData}
            setTableTitles={setPhoneNumbersTableTitles}
            actionHandler={actionHandler}
            resultNotFound={didsNotFound}
            width={"w-[calc(100vw-1420px)] min-w-[400px]"}
            scrollHeight={"h-[calc(100vh-210px)] overflow-y-auto"}
          />
        </div>
        {/* </div> */}
      </div>
      {/* </>
      </FadeIn> */}
    </div>
  );
}

export default NewGroup;
